module.exports = __webpack_public_path__ + "static/media/projectsBanner.bb19b5a0.png";